import { create } from 'zustand'

type State = {
  open: boolean
  openModal: () => void
  closeModal: () => void
}

export const useCompanyRegisterModalStore = create<State>((set) => ({
  open: false,
  openModal: () => set({ open: true }),
  closeModal: () => set({ open: false }),
}))
